// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageUserSalary {\n  padding: 16px; }\n  .PageUserSalary .PageUserSalary__title {\n    margin: 0; }\n  .PageUserSalary .PageUserSalary__subtitle {\n    margin: 0 0 8px 0; }\n  .PageUserSalary .PageUserSalary__table {\n    display: table;\n    width: 100%;\n    border: 1px solid lightgray;\n    border-spacing: 0;\n    border-collapse: collapse; }\n  .PageUserSalary .PageUserSalary__footer {\n    border-top: 1px solid lightgray;\n    font-size: x-small;\n    margin-top: 24px; }\n", ""]);
// Exports
module.exports = exports;
